<template>
  <div class="container">
    <el-card v-loading="validating" class="col-sm-6 offset-sm-3 card recover-password-confirm">
      <div slot="header" v-if="confirmed && !passwordChanged">
        <span>Восстановление пароля</span>
      </div>
      <el-result v-if="confirmed === false" class="result" icon="error" title="Неверная ссылка" />
      <el-form
        :model="form"
        v-if="confirmed && !passwordChanged"
      >
        <el-form-item label="Новый пароль" :error="getFieldError()">
          <el-input
            name="password"
            v-model="form.password"
            show-password
            v-validate="'required'"
          >
          </el-input>
        </el-form-item>
        <div class="buttons">
          <el-button :loading="loading" type="primary" @click="submit">Сохранить</el-button>
        </div>
      </el-form>
      <el-result v-if="passwordChanged" class="result" icon="success" title="Пароль успешно изменён">
        <template slot="subTitle">
          {{$t('Now you can')}} <router-link to="/auth">{{$t('sign in')}}</router-link> {{$t('to customer portal')}}
        </template>
      </el-result>
    </el-card>
  </div>
</template>

<script>
import { Result } from 'element-ui'
import axios from 'axios'

export default {
  name: 'reg-confirm',
  components: {
    [Result.name]: Result
  },
  data () {
    return {
      validating: true,
      confirmed: null,
      loading: false,
      passwordChanged: false,
      token: this.$route.query.token,
      form: {
        password: ''
      }
    }
  },
  mounted() {
    if (!this.$route.query.hasOwnProperty('token')) {
      this.confirmed = false
      this.validating = false
    } else {
      axios.get('profile/validateToken', {
        params: {
          token: this.$route.query.token
        }
      }).then(promise => {
        this.validating = false
        this.confirmed = promise.data.results
      }).catch(error => {
        console.log(error.response.data.error)
      })
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.loading = true
            axios.post('profile/updatePassword', {
              'token': this.token,
              'password': this.form.password
            }).then(promise => {
              this.loading = false
              if (promise.data.success) {
                this.passwordChanged = true
              }
            }).catch(error => {
              this.loading = false
              this.$notify(
                {
                  message: error.response.data.error,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
            })
          }
        })
    },
    getFieldError () {
      return this.$t(this.errors.first('password'))
    }
  }
}

</script>

<style scoped>
.el-result svg.icon-error {
    fill: #f56c6c;
}
.confirm-success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
i {
  font-size: 60px;
  color: #FB7954;
  margin-bottom: 24px;
}
h5 {
  text-align: center;
}
.recover-password-confirm {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.recover-password-confirm >>> .el-card__header {
  border-bottom: none;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
.recover-password-confirm >>> svg.icon-error {
  fill: #f56c6c
}
.recover-password-confirm >>> svg.icon-success {
  fill: #67c23a
}
.recover-password-confirm >>> .el-result__icon {
  margin-bottom: 8px;
}
.recover-password-confirm >>> .card-body {
  height: 100% !important;
}
.recover-password-confirm >>> .buttons {
  text-align: right;
}

</style>
